//#region src/Checkbox/utils.ts
function isIndeterminate(checked) {
	return checked === "indeterminate";
}
function getState(checked) {
	return isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}

//#endregion
export { getState, isIndeterminate };
//# sourceMappingURL=utils.js.map